// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonLink_root__QYRIO","button":"ButtonLink_button__04ypO"};